"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var postMessage = function (data, target, origin) {
    if (origin === void 0) { origin = '*'; }
    return target === null || target === void 0 ? void 0 : target.postMessage(data, { targetOrigin: origin });
};
/**
 * It listens for a specific message type, and when it receives it, it calls the event handler with the
 * message payload and a function to send a message back to the sender
 * @param {string} watch - string
 * @param {EventHandler} eventHandler - This is the function that will be called when the event is
 * triggered.
 * @returns An object with two properties: history and sendToParent.
 */
var useMessage = function (watch, eventHandler) {
    var _a = (0, react_1.useState)([]), history = _a[0], setHistory = _a[1];
    var _b = (0, react_1.useState)(), origin = _b[0], setOrigin = _b[1];
    var _c = (0, react_1.useState)(null), source = _c[0], setSource = _c[1];
    var originRef = (0, react_1.useRef)();
    var sourceRef = (0, react_1.useRef)(null);
    originRef.current = origin;
    sourceRef.current = source;
    var sendToSender = function (data) {
        return postMessage(data, sourceRef.current, originRef.current);
    };
    var sendToParent = function (data) {
        var opener = window.opener;
        if (!opener)
            throw new Error('Parent window has closed');
        postMessage(data, opener);
    };
    var onWatchEventHandler = (0, react_1.useCallback)(
    // tslint:disable-next-line: no-shadowed-variable
    function (_a) {
        var origin = _a.origin, source = _a.source, data = _a.data;
        var type = data.type, payload = data.payload;
        if (type === watch) {
            setSource(source);
            setOrigin(origin);
            setHistory(function (old) { return __spreadArray(__spreadArray([], old, true), [payload], false); });
            if (typeof eventHandler === 'function')
                eventHandler(sendToSender, payload);
        }
    }, [watch, eventHandler, setSource, setOrigin]);
    (0, react_1.useEffect)(function () {
        window.addEventListener('message', onWatchEventHandler);
        return function () { return window.removeEventListener('message', onWatchEventHandler); };
    }, [watch, source, origin, onWatchEventHandler]);
    return { history: history, sendToParent: sendToParent };
};
exports.default = useMessage;
